import * as React from "react"
import PropTypes from "prop-types"

const List = ({listItems, type}) => {
  return (
    <ul className={`${type === "dash" ? "list type-dash" : "list"}`}
    style={{ columnCount: `${listItems.length > 3 ? "2" : "1"}`}}
    >
        {
          listItems.map((item, i) => {
            return(
              <li className="list-item" key={i}>{item}</li>
            )
          })
        }
    </ul>     
  )
}

List.propTypes = {
  listItems: PropTypes.array,
  type: PropTypes.string,
}

export default List
